/******************************************************************************************
 *	Region Code to Language filter
 *******************************************************************************************/
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.regionCodeToLanguage', []).filter(
    'regionCodeToLanguage',
    /* @ngInject */
    function(regionCodeToLang) {
      return function(input) {
        return regionCodeToLang.get(input) || '';
      };
    }
  );
})();
